(function () {
  // Exacte selector van jouw notify button:
  const NOTIFY_SELECTORS = [
    'button.restock-alerts-notify-button'
  ];

  function findForm(target) {
    return (
      target?.closest?.('form[is="product-form"], form[action*="/cart/add"]') ||
      document.querySelector('form[is="product-form"], form[action*="/cart/add"]')
    );
  }

  function findAtcArea(form) {
    return form?.querySelector?.('[data-atc-area]') || null;
  }

  function findNotifyNodes(form) {
    if (!form) return [];
    const nodes = [];
    for (const sel of NOTIFY_SELECTORS) {
      form.querySelectorAll(sel).forEach((n) => nodes.push(n));
    }
    return nodes;
  }

  // Debounce: 1 update per repaint (voorkomt “burst” lag)
  let rafId = null;
  let pending = null;

  function applyState(form, available) {
    if (!form) return;

    // 1) ATC area: show/hide (geen whitespace)
    const atc = findAtcArea(form);
    if (atc) atc.style.display = available ? '' : 'none';

    // 2) Notify: nooit zichtbaar bij available=true (ook niet “kort”)
    const notifyNodes = findNotifyNodes(form);

    if (available) {
      // Force hide met !important via cssText zodat app styles het niet overrulen
      notifyNodes.forEach((n) => {
        n.style.cssText = (n.style.cssText || '') + ';display:none !important;';
      });
    } else {
      // Sold out: laat de app bepalen of hij zichtbaar moet zijn
      // We halen alleen onze display override weg
      notifyNodes.forEach((n) => {
        n.style.removeProperty('display');
      });
    }
  }

  function scheduleApply(form, available) {
    pending = { form, available: !!available };

    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = null;
      if (!pending) return;
      applyState(pending.form, pending.available);
      pending = null;
    });
  }

  function onVariantEvent(e) {
    const detail = e.detail || {};
    const variant = detail.variant || detail.currentVariant || detail.selectedVariant || null;

    const form = findForm(e.target);
    if (!form) return;

    if (variant && typeof variant.available === 'boolean') {
      scheduleApply(form, variant.available);
    } else {
      // fallback: veel themes zetten submit disabled bij sold out
      const btn = form.querySelector('button[type="submit"], [type="submit"]');
      const isDisabled =
        btn?.hasAttribute?.('disabled') || btn?.getAttribute?.('aria-disabled') === 'true';
      scheduleApply(form, !isDisabled);
    }
  }

  // Luister naar de meest voorkomende variant events
  document.addEventListener('variant:change', onVariantEvent);
  document.addEventListener('variant:changed', onVariantEvent);
  document.addEventListener('product:variant-change', onVariantEvent);
  document.addEventListener('product:variant-changed', onVariantEvent);

  // Init bij laden
  window.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form[is="product-form"], form[action*="/cart/add"]');
    if (!form) return;

    // Als theme submit disabled bij sold out:
    const btn = form.querySelector('button[type="submit"], [type="submit"]');
    const isDisabled =
      btn?.hasAttribute?.('disabled') || btn?.getAttribute?.('aria-disabled') === 'true';

    scheduleApply(form, !isDisabled);
  });
})();
